import React from 'react'
import PropTypes from 'prop-types'
import {Blocks} from '@builder.io/sdk-react'
import {
    CarouselContent,
    CarouselItem,
    slidesVisibleValuesMobile,
    slidesVisibleValuesDesktop
} from '@/components/ui/carousel'
import {defaultSlide} from '../../carousel/defaultConfig'

export const DeprecatedCustomCarouselContent = (props) => {
    const {
        slides,
        slidesVisible,
        slidesVisibleMobile,
        slidePadding,
        slidePaddingMobile,
        builderBlock,
        attributes
    } = props
    return (
        <CarouselContent {...attributes} data-testid="carouselContent-CarouselContent">
            {slides?.map((slide, index) => (
                <CarouselItem
                    key={index}
                    slidesVisible={slidesVisible}
                    slidesVisibleMobile={slidesVisibleMobile}
                    slidePadding={slidePadding}
                    slidePaddingMobile={slidePaddingMobile}
                    data-testid="carouselContent-CarouselItem"
                >
                    <Blocks
                        path={`component.options.slides.${index}.content`}
                        blocks={[slide]}
                        parent={builderBlock?.id}
                        data-testid="carouselContent-Blocks"
                    />
                </CarouselItem>
            ))}
        </CarouselContent>
    )
}

DeprecatedCustomCarouselContent.propTypes = {
    attributes: PropTypes.object,
    builderBlock: PropTypes.object,
    slides: PropTypes.arrayOf(PropTypes.object.isRequired),
    slidesVisible: PropTypes.string,
    slidesVisibleMobile: PropTypes.string,
    slidePadding: PropTypes.string,
    slidePaddingMobile: PropTypes.string
}

export const DeprecatedCarouselContentDefinition = {
    component: DeprecatedCustomCarouselContent,
    name: 'CarouselContent',
    hideFromInsertMenu: true,
    canHaveChildren: true,
    noWrap: true,
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    defaultStyles: {
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    inputs: [
        {
            name: 'slides',
            type: 'list',
            subFields: [
                {
                    name: 'content',
                    type: 'uiBlocks',
                    defaultValue: Array(3).fill(defaultSlide)
                }
            ],
            defaultValue: Array(6).fill(defaultSlide)
        },
        {
            name: 'slidesVisible',
            friendlyName: 'Number of Slides Visible',
            type: 'string',
            enum: slidesVisibleValuesDesktop,
            defaultValue: '1',
            helperText: 'Number of slides visible on devices larger than mobile'
        },
        {
            name: 'slidesVisibleMobile',
            friendlyName: 'Number of Slides Visible on Mobile',
            type: 'string',
            enum: slidesVisibleValuesMobile,
            defaultValue: '1',
            helperText: 'Number of slides visible on mobile devices'
        },
        {
            name: 'slidePadding',
            friendlyName: 'Padding Between Slides',
            type: 'string',
            enum: Array.from({length: 7}, (v, i) => i.toString()),
            defaultValue: '2',
            helperText: 'Padding between slides'
        },
        {
            name: 'slidePaddingMobile',
            friendlyName: 'Padding Between Slides Mobile',
            type: 'string',
            enum: Array.from({length: 7}, (v, i) => i.toString()),
            defaultValue: '2',
            helperText: 'Padding between slides on mobile'
        }
    ]
}
